import { useTranslation } from 'react-i18next';
import TextareaField from 'shared/components/form/TextareaField';
import TextField from 'shared/components/form/TextField';
import { UpdateActorSettingFormT } from 'shared/form-values/actor-settings';

const Form = () => {
  const { t } = useTranslation();

  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <TextField<UpdateActorSettingFormT>
        name="name"
        label={t('forms.name')}
        placeholder="Enter name"
        required
        {...fieldProps}
      />
      <TextField<UpdateActorSettingFormT>
        name="text"
        label={t('forms.text')}
        placeholder="Enter text"
        required
        {...fieldProps}
      />
      <TextareaField<UpdateActorSettingFormT>
        name="description"
        label={t('forms.text')}
        placeholder="Enter description"
        {...fieldProps}
      />
    </>
  );
};

export default Form;
